/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Document plus additional details for detail screens.
 * @export
 * @interface DocumentDetailed
 */
export interface DocumentDetailed {
    /**
     * 
     * @type {number}
     * @memberof DocumentDetailed
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentDetailed
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentDetailed
     */
    uploadedBy: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentDetailed
     */
    claimId: number;
    /**
     * Optional folder ID for organizing documents within a claim
     * @type {number}
     * @memberof DocumentDetailed
     */
    folderId?: number | null;
    /**
     * Kind of document (insurer or contractor)
     * @type {string}
     * @memberof DocumentDetailed
     */
    kind: DocumentDetailedKindEnum;
    /**
     * 
     * @type {string}
     * @memberof DocumentDetailed
     */
    filename: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDetailed
     */
    mimeType: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentDetailed
     */
    sizeBytes: number | null;
    /**
     * Document parsing status
     * @type {string}
     * @memberof DocumentDetailed
     */
    parseStatus: DocumentDetailedParseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof DocumentDetailed
     */
    parseError?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DocumentDetailed
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof DocumentDetailed
     */
    readonly updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof DocumentDetailed
     */
    readonly uploaderName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDetailed
     */
    readonly companyName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentDetailed
     */
    readonly estimateCount?: number | null;
}


/**
 * @export
 */
export const DocumentDetailedKindEnum = {
    Insurer: 'insurer',
    Contractor: 'contractor'
} as const;
export type DocumentDetailedKindEnum = typeof DocumentDetailedKindEnum[keyof typeof DocumentDetailedKindEnum];

/**
 * @export
 */
export const DocumentDetailedParseStatusEnum = {
    Pending: 'pending',
    Parsed: 'parsed',
    Failed: 'failed'
} as const;
export type DocumentDetailedParseStatusEnum = typeof DocumentDetailedParseStatusEnum[keyof typeof DocumentDetailedParseStatusEnum];


/**
 * Check if a given object implements the DocumentDetailed interface.
 */
export function instanceOfDocumentDetailed(value: object): value is DocumentDetailed {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('uploadedBy' in value) || value['uploadedBy'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('filename' in value) || value['filename'] === undefined) return false;
    if (!('mimeType' in value) || value['mimeType'] === undefined) return false;
    if (!('sizeBytes' in value) || value['sizeBytes'] === undefined) return false;
    if (!('parseStatus' in value) || value['parseStatus'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function DocumentDetailedFromJSON(json: any): DocumentDetailed {
    return DocumentDetailedFromJSONTyped(json, false);
}

export function DocumentDetailedFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentDetailed {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'uploadedBy': json['uploadedBy'],
        'claimId': json['claimId'],
        'folderId': json['folderId'] == null ? undefined : json['folderId'],
        'kind': json['kind'],
        'filename': json['filename'],
        'mimeType': json['mimeType'],
        'sizeBytes': json['sizeBytes'],
        'parseStatus': json['parseStatus'],
        'parseError': json['parseError'] == null ? undefined : json['parseError'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'uploaderName': json['uploaderName'] == null ? undefined : json['uploaderName'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
        'estimateCount': json['estimateCount'] == null ? undefined : json['estimateCount'],
    };
}

export function DocumentDetailedToJSON(json: any): DocumentDetailed {
    return DocumentDetailedToJSONTyped(json, false);
}

export function DocumentDetailedToJSONTyped(value?: Omit<DocumentDetailed, 'id'|'createdAt'|'updatedAt'|'uploaderName'|'companyName'|'estimateCount'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'uploadedBy': value['uploadedBy'],
        'claimId': value['claimId'],
        'folderId': value['folderId'],
        'kind': value['kind'],
        'filename': value['filename'],
        'mimeType': value['mimeType'],
        'sizeBytes': value['sizeBytes'],
        'parseStatus': value['parseStatus'],
        'parseError': value['parseError'],
    };
}

